import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual, isEmpty, isUndefined } from 'lodash';
import classNames from 'classnames';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import { Select } from '@components/common';

import SelectOption from './selectOption';

class DropDown extends Component {
	constructor(props) {
		super(props);
		this.debounceTimeout = null;
		this.debounceFunction = null;
		this.state = {
			value : props.value,
		};
	}

	UNSAFE_componentWillReceiveProps = ({ value }) => {
		const lastState = this.state;
		if (!isEqual(value, lastState.value)) this.setState({ value });
	}

	shouldComponentUpdate = ({ rawErrors, schema : { data, loading, optionComponentNeeded } }, { value }) => {
		const lastProps = this.props;
		const lastState = this.state;
		return (
			!isEqual(value, lastState.value)
		|| !isEqual(rawErrors, lastProps.rawErrors)
		|| !isEqual(data, lastProps.schema.data)
		|| !isEqual(loading, lastProps.schema.loading)
		|| !isEqual(optionComponentNeeded, lastProps.schema.optionComponentNeeded)
		);
	}

	onChange = (data) => {
		const value = data ? data.value.toString() : '';
		this.setState({ value });

		/**
		 * Clear debounceTimeout to prevent updating the Store
		 * multiple times using the JS native function
		 * clearTimeout
		 */
		if (this.debounceTimeout !== null) clearTimeout(this.debounceTimeout);

		this.debounceFunction = () => {
			const { onChange } = this.props;
			onChange(value);
		};
		this.debounceTimeout = setTimeout(this.debounceFunction, 100);
	}

	onInputChange = (data) => {
		const { options : { onInputChangeFunction } } = this.props;
		if (!isUndefined(onInputChangeFunction)) onInputChangeFunction(data);
	}

	render() {
		const {
			placeholder,
			options : {
				label,
				wrapperClassName,
				inputClassName,
				large,
				selectClassName,
				labelFont,
				disabled,
				clearable,
			},
			rawErrors,
			schema : {
				data,
				loading,
				optionComponentNeeded,
			},
		} = this.props;
		const { value } = this.state;
		return (
			<div className={wrapperClassName}>
				<FormGroup
					bsSize={large ? 'lg' : undefined}
					className={classNames(inputClassName, { 'has-error' : !isEmpty(rawErrors) })}
				>
					<ControlLabel className={classNames(`${labelFont} font-size-15 color-gray-mine-shaft`,
						{ 'color-pink-brink' : !isEmpty(rawErrors) })}
					>
						{ label }
					</ControlLabel>
					<Select
						placeholder={placeholder}
						value={value}
						name={`dropdown-${label}`}
						onChange={this.onChange}
						onInputChange={this.onInputChange}
						options={data}
						isLoading={loading}
						className={selectClassName}
						optionComponent={optionComponentNeeded && SelectOption}
						disabled={disabled}
						clearable={clearable}
					/>
				</FormGroup>
			</div>
		);
	}
}

DropDown.propTypes = {
	onChange : PropTypes.func.isRequired,
	value    : PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	placeholder : PropTypes.string,
	rawErrors   : PropTypes.array,
	options     : PropTypes.shape({
		label                 : PropTypes.string,
		data                  : PropTypes.array,
		selectClassName       : PropTypes.string,
		wrapperClassName      : PropTypes.string,
		loading               : PropTypes.bool,
		inputClassName        : PropTypes.string,
		inputGroupClassName   : PropTypes.string,
		large                 : PropTypes.bool,
		labelFont             : PropTypes.string,
		onInputChangeFunction : PropTypes.func,
		disabled              : PropTypes.bool,
		clearable             : PropTypes.bool,
	}),
	schema : PropTypes.shape({
		data                  : PropTypes.array,
		loading               : PropTypes.bool,
		optionComponentNeeded : PropTypes.bool,
	}),
};

DropDown.defaultProps = {
	value       : null,
	placeholder : '',
	rawErrors   : [],
	options     : {
		label                 : '',
		selectClassName       : 'signup-select',
		wrapperClassName      : '',
		inputClassName        : '',
		inputGroupClassName   : '',
		large                 : true,
		labelFont             : 'font-regular',
		onInputChangeFunction : undefined,
		disabled              : false,
		clearable             : true,
	},
	schema : {
		data                  : [],
		loading               : false,
		optionComponentNeeded : false,
	},
};

export default DropDown;
